.wrapper {
  width: 100%;
  padding: 10px 20px 0;

  @media (min-width: 566px) {
    padding-top: 30px;
  }
}

.content {
  width: min(100%, 450px);
  margin: 0 auto;
}

.discountInfo {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.discountText {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #221e1a;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.045px;
  text-align: center;
}

.discountBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 4px 10px;
  border-radius: 8px;
  background: #E44A08;
  color: #fffbf2;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: 16px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: 0.064px;
}

.title {
  color: #221e1a;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, 'SF Pro Rounded', Nunito, 'SF Pro Text', -apple-system, BlinkMacSystemFont, 'Roboto',
    sans-serif);
  font-size: clamp(24px, 6vw, 30px);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  margin-top: 10px;
  margin-bottom: 16px;
}

.subtitle {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 20px;
  padding: 4px 8px;
  border-radius: 12px;
  background: #f2ede1;

  img {
    height: 22px;
    min-height: 22px;
  }

  p {
    margin: 0;
    color: #221e1a;
    font-size: 15px;
    font-weight: 510;
    line-height: 20px;
    letter-spacing: -0.045px;
  }
}

.comparisonCard {
  overflow: hidden;
  border: 1px solid var(--ed-border, #f2e8da);
  border-radius: 16px;
  background: #f2ede1;
}

.imageWrapper {
  position: relative;
  aspect-ratio: 335 / 258;
  overflow: hidden;
  border-radius: 16px 16px 0 0;
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.imageBadge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: max-content;
  min-height: 24px;
  padding: 4px 8px;
  border-radius: 24px;
  box-sizing: border-box;
  color: #fffbf2;
  font-family: 'SF Pro Text', 'SF Pro', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.036px;
  text-align: center;
  text-transform: uppercase;
}

.imageBadgeNow {
  background: #221E1A;
}

.imageBadgeEverydoggy {
  background: var(--ed-brand, #AE66F6);
}

.comparisonContent {
  display: flex;
  gap: 0;
  margin-top: -20px;
  border-radius: 12px;
  background: #fffefb;
  position: relative;
  z-index: 1;
}

.column {
  flex: 1 1 0;
  min-width: 0;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stat {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.statLabel {
  color: #221e1a;
  font-family: 'SF Pro Text', 'SF Pro', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 510;
  line-height: 16px;
  letter-spacing: -0.036px;
}

.statValue {
  color: #221e1a;
  font-family: 'SF Pro Text', 'SF Pro', -apple-system, BlinkMacSystemFont, 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: -0.036px;
  text-transform: uppercase;
}

.separator {
  width: 100%;
  height: 1px;
  background: #eae5da;
}

.progress {
  display: flex;
  gap: 4px;
  margin-top: auto;
}

.progressBar {
  flex: 1 1 0;
  height: 9px;
  border-radius: 2px;
}

.progressBarOrange {
  background: #f0930c;
}

.progressBarOrangeMuted {
  background: rgba(240, 147, 12, 0.3);
}

.progressBarPurple {
  background: var(--ed-brand, #ae66f6);
}

.progressBarBlack {
  background: #221E1A;
}

.progressBarGray {
  background: #221E1A;
  opacity: 0.3;
}
